export const NEARBY_PROPERTIES_CHART_LABEL_Y_AXIS = '# of Properties';
